import React from 'react';
import { Box, Grid, Skeleton, Paper } from '@mui/material';

const DashboardSkeleton = () => {
  return (
    <Box>
      <Skeleton variant="rounded" height={72} sx={{ mb: 2 }} />
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Paper sx={{ p: 2 }}>
              <Skeleton width="60%" />
              <Skeleton variant="text" width="40%" sx={{ mt: 1 }} height={40} />
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2, height: 300 }}>
            <Skeleton variant="rounded" height={260} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2, height: 300 }}>
            <Skeleton variant="rounded" height={260} />
          </Paper>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2, height: 300 }}>
            <Skeleton variant="rounded" height={260} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2, height: 300 }}>
            <Skeleton variant="rounded" height={260} />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardSkeleton;
